import { viewport } from "@telegram-apps/sdk-react";
import { useEffect } from "react";

export function useKeyboardHeightCompensation() {
  useEffect(() => {
    const visualViewport = window.visualViewport;
    if (!visualViewport) {
      return;
    }

    const handleResize = (height: number) => {
      const keyboardHeight = window.innerHeight - height;
      document.body.style.borderBottom = `${keyboardHeight}px solid transparent`;
    };

    const handleNativeResize = () => {
      handleResize(visualViewport.height);
    };

    handleNativeResize();
    visualViewport.addEventListener("resize", handleNativeResize);
    const unsub = viewport.height.sub((height) => {
      handleResize(height);
    });

    return () => {
      visualViewport.removeEventListener("resize", handleNativeResize);
      unsub();
    };
  }, []);
}
